import React from "react";
import { Row } from "react-bootstrap";

function Education() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <div className="iknow_tm_main_section">
        <div className="iknow_tm_resume">
          <div className="iknow_tm_main_title">
            <h2>
              <span className="purple"> Education &amp; Experience </span>
            </h2>
          </div>
          <div className="resume_inner">
            <div className="left">
              <div className="info_list">
                <div className="iknow_tm_resume_title">
                  <h3>Education</h3>
                  <span className="shape"></span>
                </div>
                <ul>
                  <li>
                    <div className="list_inner">
                      <div className="short">
                        <div className="job">
                          <h3>Full Stack MERN Developer</h3>
                          <span className="purple">Masai School</span>
                          <br />
                          <span className="purple"> Bengaluru, Karnataka</span>
                        </div>
                        <div className="year">
                          <span>Jan 22 - Dec 22</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="list_inner">
                      <div className="short">
                        <div className="job">
                          <h3>Master Of Computer Science</h3>
                          <span className="purple">
                            New Arts College, A.Nagar,
                          </span>
                          <br />
                          <span className="purple">University of Pune</span>
                        </div>
                        <div className="year">
                          <span>Aug 18 - Nov 20</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="list_inner">
                      <div className="short">
                        <div className="job">
                          <h3>Bachelor Of Computer Science</h3>
                          <span className="purple">
                            New Arts College, A.Nagar,
                          </span>
                          <br />
                          <span className="purple">University of Pune</span>
                        </div>
                        <div className="year">
                          <span>Jul 15 - Mar 18</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="list_inner">
                      <div className="short">
                        <div className="job">
                          <h3>HSC</h3>
                          <span className="purple">
                            New Arts College, A.Nagar,
                          </span>
                          <br />
                          <span className="purple">Univercity of Pune</span>
                        </div>
                        <div className="year">
                          <span>Jun 14 - Feb 15</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="list_inner">
                      <div className="short">
                        <div className="job">
                          <h3>SSC</h3>
                          <span className="purple">
                            Residential High School A.Nagar,
                          </span>
                          <br />
                          <span className="purple">Univercity of Pune</span>
                        </div>
                        <div className="year">
                          <span>Jul 12 - Mar 13</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="right">
              <div className="skills_list">
                <div className="info_list">
                  <div className="iknow_tm_resume_title">
                    <h3>Experience / Internship</h3>
                    <span className="shape"></span>
                  </div>
                  <ul>
                    <li>
                      <div className="list_inner">
                        <div className="short">
                          <div className="job">
                            <h3>Full Stack Developer </h3>
                            <span className="purple">
                              Webure Technologies Bengaluru, Karnataka
                            </span>
                          </div>
                          <div className="year">
                            <span>Feb 23 - Present</span>
                          </div>
                        </div>
                        <div className="text">
                          <p>
                            I have gained valuable experience working with a
                            versatile tech stack that includes React, Express,
                            Next.js, and Tailwind .
                            <br />I successfully implemented intuitive user
                            interfaces, robust server-side functionalities, and
                            responsive design elements.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="list_inner">
                        <div className="short">
                          <div className="job">
                            <h3>Web Developer </h3>
                            <span className="purple">
                              Sthayin Energy Pvt. Ltd. Ahmednagar, Maharashtra
                            </span>
                          </div>
                          <div className="year">
                            <span>Aug 21 - Jan 22</span>
                          </div>
                        </div>
                        <div className="text">
                          <p>
                            Created a responsive website with proper layout.
                            <br />
                            Developed dynamic and interactive website that
                            ensured high traffic, page views and user
                            experience.
                            <br />
                            Worked on php form to connect with Mysql Database.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="list_inner">
                        <div className="short">
                          <div className="job">
                            <h3>Full Stack Developer Internship</h3>
                            <span className="purple">
                              A2Z Infotech Ahmednagar, Maharashtra
                            </span>
                          </div>
                          <div className="year">
                            <span>Dec 19 - May 20</span>
                          </div>
                        </div>
                        <div className="text">
                          <p>
                            <span className="purple">
                              Internship project : John Pablo
                            </span>
                            <br />
                            Created a responsive Homepage and footer using
                            Bootstrap Framework. <br />
                            Worked on Mysql Database. <br />
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Row>
  );
}

export default Education;
